// extracted by mini-css-extract-plugin
export default {"textBlock":"vehicle-tabs__textBlock___syKaG"};